export const nameOf = (name) => name;
export const namesOf = (...names) => names;
//# sourceMappingURL=nameOf.js.map